import {React, useEffect,  useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login as loginService, api } from "../../../services/services";
import "./ConnectionPopUp.css";
import Dialog from "../../MyUI/Dialog/Dialog";

export default function ConnectionPopUp() {
  const [open, setOpen] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
      const handleClickOutside = (e) => {
        //navigate("/Home");
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
  
  // Login function
  const login = async () => {
    setError("");
    if (!username || !password) {
    setError("Please fill all required fields!");
    return;
    }
    try {
      const res =await loginService(username, password); // call service
      
      localStorage.setItem("ACCESS_TOKEN", res.data.access);
      localStorage.setItem("REFRESH_TOKEN", res.data.refresh);

      // Save user info
      localStorage.setItem("username", username);
      localStorage.setItem("connected", true);
      localStorage.setItem("groups", res.data.groups);
      localStorage.setItem("is_superuser", res.data.is_superuser);

      setOpen(false);
      navigate("/Home");
      window.location.reload();
    } catch (err) {
      if(String(err.message).includes('404'))
        setError("Wrong username or password! Contact your administrator.");
      else
        setError(err.message);
      setOpen(true);
    }
  };

  const GoogleSignIn = () => {
    window.location.href=`${api.defaults.baseURL}/google_login/`;
    };

  return (
    <div>
      <h1>ConnectionPopUp Page</h1>

        <Dialog open={open} onClose={() => navigate("/Home")}>
            <h2 style={{marginBottom: "50px"}}>Authentication</h2>
            
            {error && <div className="error">{error}</div>}

            <div className="form-group">
              <label>Username or Email*</label>
              <input
                className="MyInput"
                type="text"
                autoComplete="off"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Password*</label>
              <input
                className="MyInput"
                type="password"
                autoComplete="off"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <small>* required fields</small>
            <br />
            <small>
              <Link to="/forgottenPassword" className="nav_link">
                Forgot Password?
              </Link>
            </small>

            <div className="modal-actions">
              <small>
                Not a member? <Link to="/signup" className="nav_link">SIGN UP</Link>
              </small>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <nav>
                  <button
                    className="label-btn"
                    style={{ "--label-btn-color": "#1e88e5" , "--label-btn-hover-bg":"#bedcf3"}}
                    onClick={() => navigate("/Home")}
                  >
                    CANCEL
                  </button>
                </nav>
                <button className="label-btn" style={{ "--label-btn-color": "#1e88e5", "--label-btn-hover-bg":"#bedcf3" }}onClick={login}>SIGN IN</button>
              
              </div>
              
            </div>
            <div style={{ width: "100%" }}>
  
            {/* OR divider */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "16px 0",
                fontSize: "12px"
              }}
            >
              <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
              <span style={{ margin: "0 10px" }}>or</span>
              <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
            </div>

            {/* Centered button */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <button
                className="default-btn"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  padding: "8px 12px"
                }}
                onClick={GoogleSignIn}
              >
                <img
                  src="https://www.google.com/favicon.ico"
                  width={20}
                  height={20}
                  alt="Google Logo"
                />
                <span style={{ lineHeight: 1, fontSize: 12 }}>
                  Continue in with Google
                </span>
              </button>
            </div>

          </div>
        </Dialog>
    </div>
  );
}
